import { DEFAULT_CONTENT_PACK_TYPES } from 'components/ContentPackTypeItem'
import { DefaultContentPackType } from 'components/ContentPackTypeItem'
import { Project } from 'lib/types/generated-types'
import { create } from 'zustand'

interface SetupStore {
  selectedTemplate: DefaultContentPackType
  setSelectedTemplate: (template: DefaultContentPackType) => void
  project: Project | null
  setProject: (project: Project) => void
}

export const useSetupStore = create<SetupStore>((set) => ({
  selectedTemplate: DEFAULT_CONTENT_PACK_TYPES[0],
  setSelectedTemplate: (template) => set({ selectedTemplate: template }),
  project: null,
  setProject: (project) => set({ project }),
}))
